<template>
    <div class="main-view">
        <div class="m-title" ref="mainTitle">
            <div style="display: flex;height: 70px;align-items: center;justify-content: space-between;width: 100%;">
                <span>福利</span>
            </div>
        </div>

        <div class="cq-main">
            <div @click="goLottery" class="lottery-entry">
                <div class="lottery-icon-box">
                    <van-icon name="gift" size="32" color="#f55050"/>
                </div>
                <div class="lottery-text">
                    <span class="lottery-title">幸运抽奖</span>
                    <span class="lottery-desc">免费抽奖赢礼包</span>
                </div>
                <van-icon name="arrow" color="#888888"/>
            </div>

            <div class="fl-game-view" @click="goDetail">
                <img :src="gameInfo.icon" style="width: 60px;height: 60px;">
                <div class="game-title-view">
                    <span class="game-name">{{gameInfo.gameName}}</span>
                    <div class="game-tag-view">
                        <span v-for="tag in gameInfo.tagList">{{tag}}</span>
                    </div>
                    <span>{{gameInfo.gameTopic}} <span style="color: #15a26d;margin-left: 15px;">{{gameInfo.gameSize}}</span></span>
                </div>
            </div>

            <div style="text-align: left;">
                <div style="color: #ee3811;font-size: 14px;font-weight: bold;margin-top: 15px;">霸星传奇签到领充值</div>
                <div style="text-align: left;font-size: 12px;color: #666666;margin-top: 8px;">即日起，每天签到可领取游戏内20充值，需绑定手机号码或帐号为手机号码注册，请再特惠充值处领取</div>
            </div>

            <div v-if="!isLogin" style="font-size: 12px;color: #888888;margin: 20px 0;user-select: none;">
                您还未登录，请先<span @click="showLogin = true" style="margin-left: 5px;color: #ee3811;cursor: pointer;font-weight: bold;">登录</span>
            </div>
            <div v-else style="display: flex;flex-direction: column;align-items: flex-start;">
                <div v-if="!!bindInfo" style="font-size: 13px;color: #333333;margin-top: 10px;width: 100%;">
                    <div style="text-align: left;">已绑定传奇角色: {{bindInfo}} </div>
                    <div @click="bindInfo = ''" style="color: #888888;margin-left: 5px;cursor: pointer;font-size: 12px;text-align: right;">重新绑定?</div>
                </div>
                <div v-else style="width: 100%; text-align: left;margin-top: 15px;">
                    <span style="font-size: 13px;color: #333333">请先绑定您的霸星传奇角色</span>
                    <div style="width: 100%; display: flex;margin-top: 5px;align-items: center;justify-content: space-between;">
                        <van-popover v-model="showServerSelector" trigger="click"  placement="bottom-start">
                            <div style="width: 110px;max-height: 124px;overflow-y: auto;font-size: 12px;color: #5e5e5e;padding: 0 15px;box-sizing: border-box;">
                                <div @click="onConfirm(index)" v-for="(item,index) in serverNameList" style="height: 30px;display: flex;align-items: center;justify-content: center;cursor: pointer;border-bottom: 1px solid #f8f8f8;">
                                    <span>{{item}}</span>
                                </div>
                            </div>
                            <template #reference>
                                <van-field @click="openSelectorPopup" :readonly="true" label="" style="width: 105px;"  label-width="0"  placeholder="请选择区服" class="border-input" v-model="serverName">
<!--                                    <template #right-icon>
                                        <van-icon name="arrow" color="#888888" />
                                    </template>-->
                                </van-field>
                            </template>
                        </van-popover>
                        <van-field label="" label-width="0" style="width: 120px;margin-left: 5px;" placeholder="传奇角色名" class="border-input" v-model="roleName">
                        </van-field>
                        <div @click="submitBind" style="padding: 8px 10px;background-color: #1192ee;color: #FFFFFF;border-radius: 4px;cursor: pointer;font-size: 12px;">绑定</div>
                    </div>

                </div>
                <div class="sign-view">
                    <div style="background-color: #ffffff;color: #ee3811; padding: 0 5px;position: absolute;height: 20px;display: flex;align-items: center;top: -10px;">今日签到</div>
                    <div v-if="status === 0" >请先绑定</div>
                    <div @click="submit" v-else-if="status === 1" style="display: inline-block; padding: 5px 26px;background-color: #ee3811;color: #FFFFFF;border-radius: 4px;cursor: pointer;">签到</div>
                    <div v-else-if="status === 2" >今天已签到</div>
                </div>
            </div>

        </div>

        <div class="me-login-view" v-if="showLogin" @click.self="showLogin = false">
            <home-login @login-success="resetPage"></home-login>
        </div>

        <home-tabbar></home-tabbar>
    </div>
</template>

<script>


import homeTabbar from "@/components/HomeTabbar.vue";
import {webTokenRequest} from "@/api/request";
import {Toast} from "vant";
import HomeLogin from "@/components/HomeLogin.vue";

export default {
    name: 'Fuli.vue',
    components: {HomeLogin, homeTabbar},
    data() {
        return {
            showLogin: false,
            isLogin: false,
            gameInfo: {},
            serverName: '请选择区服',
            serverCode: '',
            roleName: '',
            bindInfo: '',
            status: 0,
            showServerSelector: false,
            serverList: [],
            serverNameList: [],
        };
    },
    mounted() {
        this.queryGameInfo();
        let token = localStorage.getItem('web_token');
        if (token) {
            this.isLogin = true;
            this.queryServerList();
            this.querySignInData();
        }
    },
    methods: {
        goLottery() {
            this.$router.push("/home/lottery");
        },
        resetPage() {
            this.isLogin = true;
            this.queryServerList();
            this.querySignInData();
            this.showLogin = false;
        },
        submit() {
            let options = {
                url:"/web/bxcqSignIn",
                data: {}
            };
            webTokenRequest(options).then(res => {
                if (res.data.success) {
                    Toast('签到成功');
                    this.querySignInData();
                }
                else {
                    this.$toast(res.data.error.message);
                }
            });
        },
        submitBind() {
            if (!this.serverCode) {
                Toast('请选择游戏区服');
                return;
            }
            if (!this.roleName) {
                Toast('请输入角色名称');
                return;
            }
            let options = {
                url:"/web/bindBxcqRole",
                data: {
                    server_code: this.serverCode,
                    server_name: this.serverName,
                    role_name: this.roleName,
                }
            };
            webTokenRequest(options).then(res => {
                if (res.data.success) {
                    Toast('游戏角色绑定成功');
                    this.querySignInData();
                }
                else {
                    this.$toast(res.data.error.message);
                }
            });
        },
        queryServerList() {
            let options = {
                url:"/web/getBxcqServerList",
                method: 'get'
            };
            webTokenRequest(options).then(res => {
                if (res.data.success) {
                    this.serverList = res.data.data;
                    this.serverNameList = [];
                    this.serverList.forEach(e => {
                        this.serverNameList.push(e.server_name);
                    })
                }
            });
        },
        querySignInData() {
            let options = {
                url:"/web/getBxcqSignInInfo",
                method: 'get'
            };
            webTokenRequest(options).then(res => {
                if (res.data.success) {
                    this.status = res.data.data.status;
                    this.bindInfo = res.data.data.bindInfo;
                }
                else if(res.data.error.code === '911'){
                    Toast.fail('登录已失效，请重新登录');
                    localStorage.removeItem('web_baseInfo');
                    localStorage.removeItem('web_token');
                    this.isLogin = false;
                }
            });
        },
        openSelectorPopup() {
        },
        onConfirm(index) {
            this.serverName = this.serverNameList[index];
            this.serverCode = this.serverList[index].server_code;
            this.showServerSelector = false;
        },
        queryGameInfo() {
            let options = {
                url:"/web/getGameInfo?id=128",
                method: 'get'
            };
            webTokenRequest(options).then(res => {
                this.showLoading = false;
                if (res.data.success) {
                    this.gameInfo = res.data.data;
                }
            });
        },
        goDetail() {
            this.$router.push("/detail/128");
        },
    }
};
</script>

<style scoped>
    .main-view {
        width: 100%;
        height: 100vh;
        overflow-y: scroll;
        background-color: #f5f5f5;
        position: relative;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-view::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }
    .m-title {
        display: flex;
    }
    .lottery-entry {
        display: flex;
        align-items: center;
        padding: 15px 20px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 10px;
        margin-bottom: 15px;
        cursor: pointer;
    }
    .lottery-icon-box {
        width: 50px;
        height: 50px;
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .lottery-text {
        flex: 1;
        margin-left: 15px;
        text-align: left;
    }
    .lottery-title {
        display: block;
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
    }
    .lottery-desc {
        display: block;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        margin-top: 3px;
    }
    .van-field {
        outline: 1px #dbdbdb solid;
        border-radius: 3px;
    }
    .van-cell {
        padding: 6px 16px;
    }
    .van-field:focus-within {
        outline: 2px #7a69be solid;
    }
    .cq-main {
        width: 90%;
        margin: 110px auto 0;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;
    }
    .fl-game-view {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        position: relative;
        background-color: rgba(218, 218, 218, 0.25);
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid rgba(218, 218, 218, 0.4);
    }
    .game-title-view {
        display: flex;
        height: 65px;
        color: #666666;
        margin-left: 25px;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 14px;
    }
    .game-name {
        text-align: left;
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    }
    .game-tag-view {
        display: flex;
        white-space: nowrap;
        font-size: 11px;
    }
    .game-tag-view span {
        margin-right: 10px;
        //background-color: rgba(238, 109, 109, 0.1);
        border: 1px solid #f14848;
        border-radius: 3px;
        color: #f14848;
        padding: 1px 5px;
    }
    .me-login-view {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
    }
    .sign-view {
        width: 100%;
        font-size: 12px;
        text-align: left;
        color: #666666;
        margin-top: 15px;
        position: relative;
        border: 1px solid #dadada;
        padding: 20px 15px;
        border-radius: 4px;
        box-sizing: border-box;
    }
</style>